import { ModalCustom } from "components/ModalCustom";
import { Body, InputContainer } from "./style";
import { Form } from "react-bootstrap";
import { CustomInput } from "components/CustomInput";
import { useMaskInput } from "hooks/useMaskInput";
import { IDadosParceiro } from "features/core/pages/Cadastro/Interfaces/IDadosParceiro";
import { Required } from "components/Required";

interface IProps {
  show: boolean;
  handleClose: () => void;
  onConfirm: () => void;
  setParceiro: (dados: IDadosParceiro) => void;
  parceiro: IDadosParceiro;
  acao: "Adicionar" | "Atualizar";
}

export function ModalParceiros({
  show,
  handleClose,
  onConfirm,
  setParceiro,
  parceiro,
  acao,
}: IProps) {
  const { mInputCNPJ } = useMaskInput();

  const onChangeCNPJ = (event: any) => {
    let cnpj = mInputCNPJ(event);
    setParceiro({ ...parceiro, cnpj });
    return cnpj;
  };

  const onChangeRazaoSocial = (event: any) => {
    setParceiro({
      ...parceiro,
      razaoSocial: event.target.value,
    });
    return event.target.value;
  };

  const onChangeNomeFantasia = (event: any) => {
    setParceiro({
      ...parceiro,
      nomeFantasia: event.target.value,
    });
    return event.target.value;
  };

  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title={`${acao} parceiro`}
      centered
      footer
      footerConfirmButton
      confirmButtonText={acao}
      onConfirm={onConfirm}
      size={"lg"}
      disabledConfirmButton={
        !parceiro ||
        !parceiro.cnpj ||
        !parceiro.nomeFantasia ||
        !parceiro.razaoSocial
      }
    >
      <Body>
        <Form>
          <InputContainer>
            <Form.Group>
              <Form.Label>
                Razão social <Required />
              </Form.Label>
              <CustomInput
                type="text"
                placeholder="Digite a razão social"
                style={{ height: "2.2rem" }}
                onChange={onChangeRazaoSocial}
                value={parceiro.razaoSocial}
                disabled={acao !== "Adicionar"}
              />
            </Form.Group>
          </InputContainer>
          <InputContainer>
            <Form.Group>
              <Form.Label>
                Nome fantasia <Required />
              </Form.Label>
              <CustomInput
                type="text"
                placeholder="Digite o nome fantasia"
                style={{ height: "2.2rem" }}
                onChange={onChangeNomeFantasia}
                value={parceiro.nomeFantasia}
              />
            </Form.Group>
          </InputContainer>
          <InputContainer>
            <Form.Group>
              <Form.Label>
                CNPJ <Required />
              </Form.Label>
              <CustomInput
                type="text"
                placeholder="Digite o CNPJ"
                style={{ height: "2.2rem" }}
                onChange={onChangeCNPJ}
                value={parceiro.cnpj}
              />
            </Form.Group>
          </InputContainer>
        </Form>
      </Body>
    </ModalCustom>
  );
}
